import React from 'react';
import Navbar from '../components/layout/navbar/Navbar';
import Footer from '../components/layout/footer/Footer';
import Greeting from '../components/layout/greeting/Greeting';
import Skills from '../components/layout/skills/Skills';

const Home = () => {
  return (
    <div>
      <Navbar />
      <Greeting />
      <Skills />
      <Footer />
    </div>
  );
};

export default Home;
